import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import { Link, useLocation, useParams } from "react-router-dom";
import "../../../assets/css/cms/Products.css";
import FeedbackTool from "./CPFeedbackTool";
import ManagePredictor from "./predictorTool";
import PermissionDenied from "../../cms/common/permissionDenied";
import { useSelector } from "react-redux";
import ManageProductDialer from "./ProductDialer";


function ToolsHome(props) {
  const router = useLocation();
  const { param } = useParams();
  let relatedPath = router.pathname.split("/add-edit")[0];
  const [activeComponent, setActiveComponent] = useState();
  const { userPermission } = useSelector((state) => {
    return state.userData;
  });

  const Tools_ROUTES = [
    {
      path: "",
      exact: true,
      value: "Map Tools Feedbacks",
      element: <FeedbackTool />,
    },
    {
      path: "dialer-push",
      exact: true,
      value: "Manage push to dialer",
      element: <ManageProductDialer />,
      application: "college_predictor",
      action: "Can Manage Product Push to Dialer",
    },
    {
      path: "manage-predictor",
      exact: true,
      value: "Manage Predictor Tool",
      element: <ManagePredictor />,
      application: "manage_predictor_tools_cnext_manage_tools",
      action: "Manage Predictor Tools",
    },
  ];

  // function to find permissions
  const findPermission = (contentType, permissionName) => {
    let authorized = false;
    const userPermissions = userPermission?.data;

    if (userPermission) {
      if (permissionName == "Can Manage Product Push to Dialer") {

        authorized = userPermissions.some((permission) => {
          return (
            permission.content_type === contentType &&
            permission.name === permissionName
          );
        });
      } else {
        authorized = userPermissions.some((permission) => {
          return (
            permission.codename === contentType &&
            permission.name === permissionName
          );
        });
      }
    }
    console.log(authorized)
    return authorized;
  };

  useEffect(() => {
    if (param) {
      const activeComponent = Tools_ROUTES?.find((obj) => obj.path == param);

      if (activeComponent?.application && activeComponent?.action && !findPermission(activeComponent?.application, activeComponent?.action)) {
        setActiveComponent(<PermissionDenied />);
      } else
        setActiveComponent(activeComponent?.element || Tools_ROUTES[0].element);
    } else {
      setActiveComponent(Tools_ROUTES[0].element);
    }
  }, [param]);

  const getActiveClass = (path) => {
    // Set 'nav_links_active' class if the current path matches
    if (!param && path == "") {
      return "nav_links_active";
    }
    else if (path && param && router.pathname.includes(path)) {
      return "nav_links_active";
    }
  };

  return (
    <div>
      <div className="nav_container">
        <Nav className="sub_nav">
          {Tools_ROUTES.map((route, index) => (
            <Nav.Item
              key={index}
              className={getActiveClass(route.path, index)}
            >
              <Nav.Link as={Link} to={`/cms/tools/${route.path}`}>
                {route.value}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div>
      <div className="mt-4">{activeComponent}</div>
    </div>
  );


}

export default ToolsHome;
